var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import channel from '../../socket';
import { showFlash } from '../flash_show';
const SOCKET_EVENTS = Object.freeze({
    SPOTIFY_SHOW_INGESTED: 'spotify_show_ingested'
});
const onPodcastSettingsPage = (publicationId) => {
    return !!document.querySelector(`.js-backend_publication_podcast_settings_${publicationId}`);
};
const onSpotifyShowIngested = (_a) => __awaiter(void 0, [_a], void 0, function* ({ publicationId }) {
    if (onPodcastSettingsPage(publicationId)) {
        const viewPodcastButton = document.querySelector('.js-view_podcast_button');
        const message = viewPodcastButton.dataset.onIngestionCompleteMessage || '';
        yield window.up.reload('.unpoly_wrapper', { scroll: false });
        showFlash('success', message);
    }
});
if (channel) {
    const channelHandler = channel.on(SOCKET_EVENTS.SPOTIFY_SHOW_INGESTED, onSpotifyShowIngested);
    window.addEventListener('beforeunload', () => {
        channel === null || channel === void 0 ? void 0 : channel.off(SOCKET_EVENTS.SPOTIFY_SHOW_INGESTED, channelHandler);
    });
}
